export function isSafeRelativeUrl(url) {
  return typeof url === 'string' && url.startsWith('/') && !url.startsWith('//');
}
